(function (Drupal) {
  Drupal.behaviors.loadMoreWorks = {
    attach() {
      let parent = document
        .querySelector('.view-photo-contest-works')
      document
        .querySelectorAll('.button_load_more')
        .forEach(el => {
          el.addEventListener('click', e => {
            e.preventDefault();
            fetch(e.target.getAttribute('href'))
              .then(response => response.text())
              .then(resultHTML => {
                let parser = new DOMParser();
                let htmlDoc = parser.parseFromString(resultHTML, 'text/html');
                htmlDoc
                  .querySelectorAll('.view-photo-contest-works .col')
                  .forEach(newCol => {
                    parent.appendChild(newCol);
                  })

                let nextElem = htmlDoc
                  .querySelector('.button_load_more')

                if (nextElem) {
                  e.target.setAttribute('href', nextElem.getAttribute('href'))
                }
                else {
                  e.target.classList.add('visually-hidden')
                }
              })
          })
        })
    }
  }
}(Drupal))
